import Image from "next/image";
import { useRouter } from "next/router";

function index({ p, title, image, color, path }) {
  const router = useRouter();

  return (
    <div
      onClick={() => router.push(path)}
      className="cursor-pointer bg-white  h-[200px] xl:h-[232px] p-5 lg:p-8 rounded-lg"
    >
      <div
        style={{ backgroundColor: color }}
        className={`w-[50px] h-[50px] flex items-center justify-center rounded-full`}
      >
        <div className="mt-1 w-[20px] h-[20px] relative">
          <Image width={`30`} height={`30`} src={image} alt="img" />
        </div>
      </div>
      <div className="text-[20px] font-bold mt-2 capitalize">{title}</div>
      <div className="text-[12px] text-[#969696] mt-1">{p}</div>
    </div>
  );
}

export default index;
